import { Input } from "antd"

export default function CharacterAppearanceFields({ character, onChange, disabled = false, compact = false }) {
    return <div className={`grid grid-cols-2 gap-2 mb-2 ${compact ? "text-[12px]" : "text-[14px]"}`}>
        {[["eyeColour", "Eye Colour"], ["hairColour", "Hair Colour"]].map(([field, label]) => <label key={field} className="min-w-0 text-gray-500">
            {label}
            <Input aria-label={label} className="mt-2 w-full" size={compact ? "middle" : "large"} disabled={disabled}
                value={character?.[field] || ""} onChange={(e) => onChange(field, e.target.value)} />
        </label>)}
    </div>
}